import React, { useState, useEffect, useRef } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link as LinkRouter } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
// import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory, useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import DatePicker from "react-datepicker";
import RenderCustomHeader from '../component/RenderCustomHeader';
import "react-datepicker/dist/react-datepicker.css";
// import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Heading,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  MediaEmbed,
  Paragraph,
  Table,
  Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import dayjs from "dayjs";
import { RiSettings2Fill } from 'react-icons/ri';
import 'bootstrap/dist/css/bootstrap.min.css';
import { defaultConf } from "../config/DefaultConf";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import ReactPaginate from "react-paginate";

function Editproject() {
	const {id} = useParams();
	const history = useHistory();
	const [categorys, setCategorys] = useState([]);
	const [subCategorys, setSubCategorys] = useState([]);
	const [details, setDetails] = useState({});
	const [error, setError] = useState(null);
	const [errorForm, setErrorForm] = useState([]);
	const [validated, setValidated] = useState(false);
	const [defaultSelectedCategory, setDefaultSelectedCategory] = useState({});
	const [defaultSelectedSubCategory, setDefaultSelectedSubCategory] = useState({});
	const [fileList, setFileList] = useState([])
	const [fullscreen, setFullscreen] = useState(true);
	const [pageFile, setPageFile] = useState(1);
	const [limitFile, setLimitFile] = useState(15);
	const [pagesFile, setPagesFile] = useState(0);
	const [rowsFile, setRowsFile] = useState(0);
	const [modalShow, setModalShow] = React.useState(false);
	const [selectedProject, setSelectedProject] = useState("");
	const [selectedType, setSelectedType] = useState("");
	const filePath = defaultConf.uploadUrl;

	const today = new Date();
	
	const [startDate, setStartDate] = useState(new Date());
	
	const [formData, setFormData] = useState({
		projectName: '',
		clientName: '',
		country: '',
		city: '',
		district: '',
		address: '',
		startDate: '',
		endDate: '',
		duration: '',
		approxValue: '',
		categoryId: '',
		status: '',
		totalBudget: '',
		totalProgress: '',
		details: '',
		descriptions: '',
	});

	const editorRef = useRef();

	useEffect(() => {
		getDetails(id);
	}, []);


	const getDetails = (id) => {
		Api().get(`projects/${id}`)
		.then((response) => response)
		.then((detailsResponse) => {
			console.log(detailsResponse)
			if( detailsResponse.status === 200 )
			{
				const selectedCategory = detailsResponse.data.categoryId.parentId === null ? detailsResponse.data.categoryId.id : detailsResponse.data.categoryId.parentId;
				const selectedSubCategory = detailsResponse.data.categoryId.parentId === null ? null : detailsResponse.data.categoryId.id
				console.log(selectedCategory)
				console.log(selectedSubCategory)
				setDefaultSelectedCategory(selectedCategory)
				setDefaultSelectedSubCategory(selectedSubCategory)
				getCategorys(selectedCategory);
				getSubCategorys(selectedCategory, selectedSubCategory);
				
				const startDate = new Date(detailsResponse.data.startDate !== null ? detailsResponse.data.startDate : today);
				const endDate = new Date(detailsResponse.data.endDate !== null ? detailsResponse.data.endDate : today);
				const formattedStartDate = dayjs(startDate).format("DD/MM/YYYY");
				const formattedEndDate = dayjs(endDate).format("DD/MM/YYYY");
				detailsResponse.data.startDate = formattedStartDate
				detailsResponse.data.endDate = formattedEndDate
				setFormData({...formData, ['descriptions']: detailsResponse.data.descriptions || ""})
				setDetails(detailsResponse.data)
			}
		})
		.catch((err) => {
		});
	}
	
	const getFileList = async (pageNum=pageFile, limitNum=limitFile) => {
		await Api().get(`files?page=${pageNum}&limit=${limitNum}`)
		.then((response) => response)
		.then((responseFiles) => {
			console.log(responseFiles)
			const listFiles = responseFiles.data;
			setFileList(listFiles.docs);
			setPageFile(listFiles.page);
			setPagesFile(listFiles.totalPages);
			setRowsFile(listFiles.totalDocs);
			setModalShow(true)
		})
		.catch((err) => {
		})
	}

	const changePageFile = ({ selected }) => {
		console.log(selected)
		setFileList([])
		setPageFile(selected+1);
		getFileList(selected+1);
	}

	const getCategorys = (selectedId) => {
		Api().get(`categories/all`)
		.then((response) => response)
		.then((respCat) => {
			console.log(respCat)
			if( respCat?.status === 200 )
			{
				for( let i=0; i < respCat.data.length; i++)
				{
					var selectedParent = false
					if( respCat.data[i]._id === selectedId )
					{
							selectedParent = true;
					}
					respCat.data[i].selected = selectedParent
				}
				console.log(respCat.data);
				setCategorys(respCat.data);
			}
		})
		.catch((err) => {
		});
	}

	const getSubCategorys = (parentId, selectedId) => {
		Api().get(`categories?page=1&limit=10&filter=${parentId}&fields=parentId`)
		.then((response) => response)
		.then((resSubCategories) => {
			console.log(resSubCategories)
			if( resSubCategories?.status === 200 )
			{
				for( let i=0; i < resSubCategories.data.totalDocs; i++)
				{
					var selected = false
					if( resSubCategories.data.docs[i]._id === selectedId )
					{
							resSubCategories.data.docs[i].selected = true;
					}
				}
				
				setSubCategorys(resSubCategories.data.docs);
			}
		})
		.catch((err) => {
		});
	}

	const onChangeEditor = (e) => {
		setFormData({...formData, ['details']: e})
	}

	const handleChangeStartDate = (e) => {
		console.log(e)
		const date = new Date(e);
		const formatted = dayjs(date).format("DD/MM/YYYY");
		console.log(formatted)
		setFormData({...formData, startDate: formatted})
	}

	const handleChangeEndDate = (e) => {
		console.log(e)
		const date = new Date(e);

		const formatted = dayjs(date).format("DD/MM/YYYY");
		console.log(formatted)
		setFormData({...formData, endDate: formatted})
	}

	const handleChange = (e) => {
		console.log(e)
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelectCategory = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		console.log(value)
		setDefaultSelectedCategory(value)
		setDefaultSelectedSubCategory(null)
		getCategorys(value);
		getSubCategorys(value, defaultSelectedSubCategory);
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelectSubCategory = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		setDefaultSelectedSubCategory(value)
		setFormData({...formData, [key]: value})
	}

	const parseDate = (dateString) => {
		const [day, month, year] = dateString.split('/');
		return new Date(year, month - 1, day);
	}

	const currencyToNumber = (value) => {
		return Number(value.replace(/[^\d]/g, ''));
	}
	
	const handleSetIsBanner = async (e) => {
		e.preventDefault();
		const id = e.target.attributes.getNamedItem("data-id").value
		const isBanner = e.target.attributes.getNamedItem("data-is-banner").value
		var confirm_action_title = ""
		if( isBanner )
		{
			confirm_action_title = "Anda yakin menghapus project ini menjadi Home Banner?"
		}
		else
		{
			confirm_action_title = "Anda yakin project ini menjadi Home Banner?"
		}
		
		const confirm_action = await confirm(confirm_action_title);
		if (confirm_action) {
			await Api().patch(`projects/banner/${id}`)
			.then((response) => response)
			.then((res) => {
				console.log(res)
				if( res.status === 200 ){
					getDataList();
				}
			})
			.catch((err) => {
					
			});
		}
	}

	const handleSetImage = async (e) => {
		// e.preventDefault();
		const id = e.target.attributes.getNamedItem("data-id").value
		const type = e.target.attributes.getNamedItem("data-type").value

		const payload = {
			type: "Project",
		};

		if (type === "Banner") {
			payload.coverBanner = id;
		} else {
			payload.thumbnails = id;
		}

		await Api().put(`files/cover/${selectedProject}`, payload)
		.then((response) => response)
		.then((res) => {
			console.log(res)
			if( res.status === 200 ){
				window.location.reload()
			}
		})
		.catch((err) => {
				
		});
	}
	
  const handleOpenFiles = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value
    setSelectedType(type)
    setSelectedProject(id)
    setFullscreen(true)
    getFileList()
  }

  const handleCloseModal = () => {
    setModalShow(false)
    setPageFile(1);
    setPagesFile(0);
    setRowsFile(0);
  }
	
	const handleSubmit = (req) => {
		req.preventDefault();
		const form = req.currentTarget;
		if (form.checkValidity() === false) {
			req.preventDefault();
			req.stopPropagation();
			return;
		}

		setValidated(true);
		var data = new FormData(form);
		let formObject = Object.fromEntries(data.entries());
		if(formObject.subCategory === undefined || formObject.subCategory === null || formObject.subCategory === "")
		{
			formObject.categoryId = formObject.category
		}
		else
		{
			formObject.categoryId = formObject.subCategory
		}
		formObject.details = formData.details;
		console.log(today)
		const startDate = new Date(formObject.startDate !== null ? parseDate(formObject.startDate) : today);
		const endDate = new Date(formObject.endDate !== null ? parseDate(formObject.endDate) : today);
		const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
		const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
		console.log(startDate);
		console.log(formattedStartDate);
		console.log(formObject);
		formObject.startDate = formattedStartDate
		formObject.endDate = formattedEndDate
		formObject.totalBudget = currencyToNumber(formObject.totalBudget)
		formObject.totalProgress = parseFloat(formObject.totalProgress)
		
		Api().patch(`projects/${id}`, formObject)
		.then((response) => response)
		.then((data) => {
			if( data.status === 200 || data.status === 201){
				history.push('/projects');
			}
		})
		.catch((err) => {
		});
	};
    
	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				{/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="">
								<Col sm={4}>
									<h1 className="m-0">Edit Project</h1>
								</Col>
								<Col sm={2}>
									{ checkMenu('projects') &&
										<LinkRouter to="/projects"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></LinkRouter>
									}
								</Col>
								<Col sm={3}>
								</Col>
								<Col sm={3}>
									<div className="date-time float-sm-right">
											{ moment().format('dddd, DD MMMM YYYY') }
									</div>
								</Col>
							</Row>
						</Container>
					</div>
							
					<div className="content">
						<Container fluid>
							<Row>
								<Col lg={12}>
									<Card className="content-list">
										<Card.Body>
											<Col md="12">
												<Form noValidate validated={validated} onSubmit={handleSubmit}>
													<Row className="mb-3">
														<Col md="6">
															{details.thumbnails === null || typeof details.thumbnails === 'undefined' ?
																<>
																	<Button type="button" onClick={handleOpenFiles} data-id={details._id} data-type="Thumbnails">Set Thumbnail</Button><br /><br />
																</>
																:
																<>
																	<img src={filePath + details.thumbnails.uploadFile} height={300}/><br /><br />
																	<Button type="button" onClick={handleOpenFiles} data-id={details._id} data-type="Thumbnails">Change Thumbnail</Button><br /><br />
																</>
															}
														</Col>
														<Col md="6">
															{details.coverBanner === null || typeof details.coverBanner === 'undefined' ?
																<>
																	<Button type="button" onClick={handleOpenFiles} data-id={details._id} data-type="Banner">Set Banner</Button><br /><br />
																</>
																:
																<>
																	<img src={filePath + details.coverBanner.uploadFile} height="300"/><br /><br />
																	<Button type="button" onClick={handleOpenFiles} data-id={details._id} data-type="Banner">Change Banner</Button><br /><br />
																</>
															}
														</Col>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="4" controlId="validationCustom08">
															<Form.Label>Services</Form.Label>
															<Form.Control
																required
																as="select"
																name="category"
																defaultValue={defaultSelectedCategory}
																// value={defaultSelectedCategory}
																onChange={handleChangeSelectCategory}
															>
																<option value="">Select Service</option>
																{
																	categorys.map((item, i) => (
																		<option key={i} value={item._id} selected={item.selected}>{item.name}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom08">
															<Form.Label>Sub Services</Form.Label>
															<Form.Control
																// required
																as="select"
																name="subCategory"
																defaultValue={defaultSelectedSubCategory}
																// value={defaultSelectedCategory}
																onChange={handleChangeSelectSubCategory}
															>
																<option value="">Select Sub Service</option>
																{
																	subCategorys.map((item, i) => (
																		<option key={i} value={item._id} selected={item.selected}>{item.name}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Project Name</Form.Label>
															<Form.Control
																required
																type="text"
																name="projectName"
																defaultValue={details.projectName || formData.projectName}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Client Name</Form.Label>
															<Form.Control
																required
																type="text"
																name="clientName"
																defaultValue={details.clientName || formData.clientName}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Address</Form.Label>
															<Form.Control
																required
																as="textarea"
																name="address"
																defaultValue={details.address || formData.address}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Kelurahan</Form.Label>
															<Form.Control
																required
																type="text"
																name="district"
																defaultValue={details.district || formData.district}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Kota</Form.Label>
															<Form.Control
																required
																type="text"
																name="city"
																defaultValue={details.city || formData.city}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Negara</Form.Label>
															<Form.Control
																required
																type="text"
																name="country"
																defaultValue={details.country || formData.country}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Approx Value</Form.Label>
															<Form.Control
																// required
																as="textarea"
																rows={5}
																name="approxValue"
																defaultValue={details.approxValue || formData.approxValue}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Durasi</Form.Label>
															<Form.Control
																// required
																type="text"
																name="duration"
																defaultValue={details.duration || formData.duration}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Total Budget</Form.Label>
															<NumericFormat
																value={details.totalBudget || formData.totalBudget}
																onValueChange={(e) => {
																	setFormData({...formData, totalBudget: e.value})
																}}
																thousandSeparator={true}
																thousandSeparator={true}
																prefix={'IDR '}
																decimalScale={0}
																fixedDecimalScale={false}
																allowNegative={false}
																className="currency-input form-control"
																placeholder="Enter amount"
																name="totalBudget"
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Tanggal Mulai</Form.Label>
															<DatePicker 
																name="startDate" 
																format="DD/MM/YYYY" 
																value={formData.startDate || details.startDate} 
																onChange={handleChangeStartDate} 
																renderCustomHeader={(props) => (
																	<RenderCustomHeader {...props} 
																	/>
																)}
															/>
															{/* <Form.Control
																// required
																type="text"
																name="startDate"
																placeholder="DD/MM/YYYY"
																defaultValue={details.startDate || ''}
																onChange={handleChange}
															/> */}
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Tanggal Berakhir</Form.Label>
															<DatePicker 
																name="endDate" 
																format="DD/MM/YYYY" 
																value={formData.endDate || details.endDate} 
																onChange={handleChangeEndDate} 
																renderCustomHeader={(props) => (
																	<RenderCustomHeader {...props} 
																		startYear={1980}
																		endYear={20}
																	/>
																)}
															/>
															{/* <Form.Control
																// required
																type="text"
																name="endDate"
																placeholder="DD/MM/YYYY"
																defaultValue={details.endDate || ''}
																onChange={handleChange}
															/> */}
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Total Progress</Form.Label>
															<NumericFormat
																value={details.totalProgress || formData.totalProgress}
																onValueChange={(e) => {
																	setFormData({...formData, totalProgress: e.value})
																}}
																thousandSeparator={true}
																thousandSeparator={true}
																suffix={' %'}
																decimalScale={0}
																fixedDecimalScale={false}
																allowNegative={false}
																className="currency-input form-control"
																placeholder="Enter Progress in Percentage"
																name="totalProgress"
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="4" controlId="validationCustom08">
															<Form.Label>Status</Form.Label>
															<Form.Control
																required
																as="select"
																name="status"
																onChange={handleChange}
															>
																<option value="">Select Status</option>
																<option value="Planning" selected={details.status === "Planning" ? true : false}>Planning</option>
																<option value="Ongoing" selected={details.status === "Ongoing" ? true : false}>Ongoing</option>
																<option value="Completed" selected={details.status === "Completed" ? true : false}>Completed</option>
																<option value="Hold" selected={details.status === "Hold" ? true : false}>Hold</option>
																<option value="Cancelled" selected={details.status === "Cancelled" ? true : false}>Cancelled</option>
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Descriptions</Form.Label>
															<Form.Control
																// required
																as="textarea"
																rows={5}
																name="descriptions"
																defaultValue={details.descriptions || formData.descriptions}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Details</Form.Label>
															{/* <Form.Control
																required
																as="textarea"
																rows={10}
																name="details"
																defaultValue={details.details || ''}
																onChange={handleChange}
															/> */}
															{/* <input type='hidden' name="details" defaultValue={details.details || ''} /> */}
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
        													licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: details.details || formData.details,
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorRef.current = editor;
																} }
																data={ details.details || formData.details }
																onChange={ () => {
																	onChangeEditor( editorRef.current?.getData() );
																} }
															/>
														</Form.Group>	
                            <input type='hidden' defaultValue={formData.details} name="details" />
													</Row>
													{error && 
														<Alert variant="danger">
															{error}
														</Alert>
													}
													<Button type="submit">Save</Button>
												</Form>
											</Col>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</main>
			</div>
			<Footer />
			<Modal 
				show={modalShow} 
				fullscreen={fullscreen} 
				onHide={handleCloseModal}
				dialogClassName="modal-full-custom"
				scrollable={fullscreen}
			>
				<Modal.Header closeButton>
					<Modal.Title className='text-center'>
						{selectedType === "Banner" ? "Set Home Banner" : "Set Thumbnail"}
					</Modal.Title>
				</Modal.Header>
				{/* <Modal.Header style={{display: "block"}}>
				</Modal.Header> */}
				<Modal.Body>
					<Container fluid>
						<Row xs={5} md={5} lg={5} className="g-2">
							{
								fileList.map((item, i) => (
									<Col key={i}>
										<Card>
											<Card.Img variant="top" src={filePath + item.uploadFile} />
											
											<Card.Body>
												<Button variant="primary" data-id={item._id} data-type={ selectedType === "Banner" ? "Banner" : "Thumbnails" } onClick={handleSetImage}>Choose This</Button>
											</Card.Body>
										</Card>
									</Col>
								))
							}
						</Row>
					</Container>
					
				</Modal.Body>
				<Modal.Footer>
					<Container fluid>
						<Row>
							<Col lg={3} md={4}>
								<p>Total Data: {rowsFile} Page: {rowsFile ? pageFile : 0} of {pagesFile}</p>
							</Col>
							<Col lg={9} md={8}>
								<nav
									className="pagination float-sm-right"
									key={rowsFile}
									role="navigation"
									aria-label="pagination"
								>
									<ReactPaginate
										previousLabel={"< Prev"}
										nextLabel={"Next >"}
										pageCount={pagesFile}
										onPageChange={changePageFile}
										containerClassName={"pagination-list pagination"}
										pageLinkClassName={"pagination-link page-link"}
										previousLinkClassName={"pagination-previous page-link"}
										nextLinkClassName={"pagination-next page-link"}
										activeLinkClassName={"pagination-link is-current"}
										disabledLinkClassName={"pagination-link is-disabled"}
										activeClassName={"active"}
										pageClassName={"page-item"}
									/>
								</nav>
							</Col>
						</Row>
					</Container>
				</Modal.Footer>
			</Modal>
		</>
	)
}
export default Editproject